import { useTranslation } from "react-i18next";

import type { ManualTimeStatus } from "@/api/queries";
import { Badge } from "@/components/ui/badge";

const variants = {
  pending: "warning",
  approved: "success",
  rejected: "danger",
  cancelled: "neutral",
} as const;

export function ManualStatusBadge({ status }: { status: ManualTimeStatus }) {
  const { t } = useTranslation();
  return <Badge variant={variants[status]}>{t(`manual.status.${status}`)}</Badge>;
}
